import { twMerge } from 'tailwind-merge';
import { getPlatformLogoSrc } from '@/utils/constants';

interface PlatformIconProps {
  name: string;
  className?: string;
  /**
   * Optional image path used when provided; otherwise `getPlatformLogoSrc` is used
   * (including built-in default for unknown platform names).
   */
  fallback?: string | null;
}

/**
 * Renders a platform logo image for any platform name.
 * Unknown names use the default podcast image from `getPlatformLogoSrc`.
 */
export const PlatformIcon = ({ name, className, fallback = null }: PlatformIconProps) => {
  const src = fallback ?? getPlatformLogoSrc(name);
  return (
    <img
      src={src}
      alt={`${name} logo`}
      className={twMerge('size-4 rounded', className)}
      width={16}
      height={16}
    />
  );
};
